import { Button } from '../button/button.types';
import { LinkButton } from '../link-button/link-button.types';
import { ObjectValues } from '../types';

export const backgrounds = {
  primary: 'primary',
  secondary: 'secondary',
} as const;

export enum ActionTypes {
  LinkButton = 'LinkButton',
  Button = 'Button',
}

type LinkAction = {
  type: ActionTypes.LinkButton;
  action: LinkButton;
};

type ButtonAction = {
  type: ActionTypes.Button;
  action: Button;
  buttonId: string;
};

export type Modal = {
  ariaLabel: string;
  background?: ObjectValues<typeof backgrounds>;
  closeLabel: string;
  explanation?: string;
  id: string;
  onClose?: () => void;
  title?: string;
  actions?: (LinkAction | ButtonAction)[];
  onClick?: (id: string, arg?: unknown) => void;
};
